module.exports = __webpack_public_path__ + "img/bracket-4.0b810b24.svg";